import { Frequency } from './recurring.model';

export class SetStartDate {
  static readonly type = '[Recurring] Set Start Date';
  constructor(public payload: Date) {}
}

export class SetCount {
  static readonly type = '[Recurring] Set Count';
  constructor(public payload: { count: number }) {}
}

export class SetEndDate {
  static readonly type = '[Recurring] Set End Date';
  constructor(public payload: { date: Date; count: number }) {}
}

export class SetFrequency {
  static readonly type = '[Recurring] Set Frequency';
  constructor(public payload: Frequency) {}
}
